import React, { useEffect, useState } from "react";
import Topbar from "../../Topbar/Topbar";
import { useFetcher, useLocation } from "react-router-dom";
import { calender_icon } from "../../../assets/img";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { URLS } from "../../../Services/Constant";
import { get, post, put } from "../../../Services/ApiHandler";
import { toast } from "react-toastify";
import Loader from "../../Loader";
import { isDate } from "moment";
import { checkPermission } from "../../../screen/redux/api/PermissionManager";

const RoomBookingTable = ({ roomData }) => {
  // Flatten data entries for each date
  if (roomData == undefined) return null;
  const rows = Object.values(roomData && roomData).flat();
  const abbreviateSlot = (slotLabel) => {
    if (!slotLabel || typeof slotLabel !== "string") return ""; // handle null/undefined/non-string

    if (slotLabel === "Full Property Block") return "Full Property Block";

    // const periodMap = { Morning: "M", Afternoon: "A", Evening: "E" };
    const regex =
      /(Morning|Afternoon|Evening) slot (\d+) hrs (\d{1,2}[ap]m) to (\d{1,2}[ap]m)/i;

    const match = slotLabel.match(regex);
    if (!match) return slotLabel; // fallback if no match found

    const [, period, hours, startStr, endStr] = match;

    const to24Hour = (timeStr) => {
      if (!timeStr) return null;

      const time = timeStr.slice(0, -2);
      const meridian = timeStr.slice(-2).toLowerCase();

      let hour = parseInt(time, 10);
      if (isNaN(hour)) return null;

      if (meridian === "pm" && hour !== 12) hour += 12;
      if (meridian === "am" && hour === 12) hour = 0;

      return hour;
    };

    const startHr = to24Hour(startStr);
    const endHr = to24Hour(endStr);

    let displayTime = `${startStr} - ${endStr}`;
    if (startHr !== null && endHr !== null && endHr <= startHr) {
      displayTime = `${startStr} - ${endStr}`;
    }

    return `${[period] || period[0]}${hours}hrs (${displayTime})`;
  };
  console.log("mnm___((((((()))))", roomData);

  if (!roomData || Object.keys(roomData).length === 0) {
    return null;
  }
  const thStyle = {
    padding: "10px",
    fontWeight: "600",
    borderBottom: "2px solid #ddd",
  };

  const tdStyle = {
    padding: "8px 10px",
    width: "auto",
  };
  const formatTimeslot = (text) => {
    const match = text.match(
      /(\d+\s*hrs)\s*(\d{1,2}\s*[ap]m)\s*to\s*(\d{1,2}\s*[ap]m)/i
    );
    if (match) {
      const [, duration, start, end] = match;
      // Add leading 0 if hour < 10 for better display
      const formatTime = (time) =>
        time.replace(/(\d{1})(am|pm)/i, "$1$2").replace(/\s+/g, "");
      return `${duration} ${formatTime(start)} - ${formatTime(end)}`;
    }
    return text;
  };

  return (
    <div style={{ padding: "20px", fontFamily: "sans-serif" }}>
      {Object.entries(roomData).map(([date, slots]) => {
        const [Year, MM, DD] = date.split("-");
        const formate = `${DD}-${MM}-${Year}`;
        console.log("JDSALKDAS", date.split("-"), formate);
        return (
          <div
            key={date}
            style={{
              marginBottom: "30px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "15px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
          >
            <h3 style={{ marginBottom: "10px", color: "#007bff" }}>
              {" "}
              {formate}
            </h3>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                textAlign: "left",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f8f9fa" }}>
                  <th style={thStyle}>Time Slot</th>
                  <th style={thStyle}>Booked Rooms</th>
                  <th style={thStyle}>Blocked Rooms</th>
                  {/* <th style={thStyle}>Total Blocked Rooms</th> */}
                </tr>
              </thead>
              <tbody>
                {slots.map((slot, i) => (
                  <tr key={i} style={{ borderBottom: "1px solid #e0e0e0" }}>
                    <td style={{ width: "190px" }}>
                      {formatTimeslot(slot.timeslot_id)}
                    </td>
                    <td style={tdStyle}>{slot.booked_rooms}</td>
                    <td style={tdStyle}>{slot.blocked_rooms}</td>
                    {/* <td style={tdStyle}>{slot.total_blocked_rooms}</td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
};

const RoomBookingBlock = () => {
  const location = useLocation();
  const [types, setTypes] = useState(""); // block/unblock type
  const [data, setData] = useState({});
  const [isValue, setIsValue] = useState({});
  const [tabs, setTabs] = useState(0); // start with index instead of 1
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formattedObj, setFormattedObj] = useState({});

  const [isBlock, setIsBlock] = useState({
    AvailableRooms: "",
    BlockedRooms: "",
    timeSlot: {},
    Blocked: "",
  });

  const type = location?.state?.type;
  const propertyId = location?.state?.propertyId;
  const categoriedID = location?.state?.categoriedID;

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const today = new Date();
  const [fromDate, setFormDate] = useState(formatDate(today));

  const openFromDatePicker = () => {
    document.getElementById("fromDateInput")?.showPicker?.();
  };

  const getBlock = async () => {
    try {
      const url = `${URLS.AVAILABLE_ROOM}/${propertyId}/${categoriedID}?date=${fromDate}`;
      console.log("URLFOR BLOCK", url);
      const res = await get(url);
      if (res) {
        setData(res);
      }
    } catch (err) {
      console.error("Error fetching blocks:", err);
    }
  };

  // Format API timeslots into usable object
  useEffect(() => {
    if (data?.timeslots) {
      const formatted = {};
      for (const key in data.timeslots) {
        const match =
          key &&
          key?.match(
            /(\d+\s*hrs).*?(\d{1,2}(?:am|pm)\s*to\s*\d{1,2}(?:am|pm))/i
          );
        if (match && match) {
          const newKey = `${match[1].replace(/\s+/g, "")} (${match[2]
            .replace("to", "-")
            .trim()})`;
          formatted[newKey] = data.timeslots[key];
        }
      }
      setFormattedObj(formatted);
    }
  }, [data]);
  useEffect(() => {
    if (slotData.length > 0) {
      const currentSlot = formattedObj[slotData[tabs]?.label];
      if (currentSlot) {
        setIsValue(currentSlot);
        setIsBlock((prev) => ({ ...prev, timeSlot: currentSlot }));
      }
    }
  }, [tabs, formattedObj]);

  const slotData = Object.keys(formattedObj).map((label, index) => ({
    key: String(index),
    label,
  }));

  const handlerAvailable = (item, ind) => {
    const slot = formattedObj[item?.label];
    if (!slot) return;

    setTabs(ind);
    setIsValue(slot);
    setIsBlock((prev) => ({ ...prev, timeSlot: slot }));
  };

  // Update when tabs or formattedObj changes
  useEffect(() => {
    if (slotData.length > 0) {
      const currentSlot = formattedObj[slotData[tabs]?.label];
      if (currentSlot) {
        setIsValue(currentSlot);
        setIsBlock((prev) => ({ ...prev, timeSlot: currentSlot }));
      }
    }
  }, []);

  // Initial data fetch
  useEffect(() => {
    if (categoriedID && propertyId) {
      getBlock();
    }
  }, [propertyId, categoriedID, fromDate, loading]);

  // Ensure first slot is selected when data comes in
  useEffect(() => {
    console.log("slotData.length", slotData.length);
    if (slotData.length > 0 && !isValue?.total_rooms) {
      const firstSlot = formattedObj[slotData[0]?.label];
      if (firstSlot) {
        setIsValue(firstSlot);
        setIsBlock((prev) => ({ ...prev, timeSlot: firstSlot }));
        setTabs(0);
      }
    }
  }, [slotData, formattedObj, fromDate, data]);

  const handleSubmit = () => {
    console.log("BLOCKECDD", !isBlock.BlockedRooms);
    if (types === "block") {
      if (!isBlock.BlockedRooms) {
        toast.error("Kindly Added a Blocked Room Count");
        return;
      }
      if (Number(isBlock.BlockedRooms) > Number(isBlock.AvailableRooms)) {
        return toast.error("Blocked rooms cannot exceed available rooms.");
      }
    } else {
      if (!isBlock.BlockedRooms) {
        toast.error("Kindly Added a UnBlocked Room Count");
        return;
      }
      if (Number(isBlock.BlockedRooms) > Number(isBlock.Blocked)) {
        return toast.error("Unblocked rooms cannot exceed blocked rooms.");
      }
    }

    setLoading(true);

    const value = {
      property_id: propertyId,
      room_category_id: categoriedID,
      time_slot_id: isBlock?.timeSlot?.timeslot_id,
      for_date: fromDate,
      ...(types === "block"
        ? { block_count: Number(isBlock?.BlockedRooms) }
        : { unblock_count: Number(isBlock?.BlockedRooms) }),
    };

    console.log("Payload", value);

    const request =
      types === "block"
        ? post(URLS.BLOCK_METHOD, value)
        : put(URLS.UNBLOCK_METHOD, value);

    request
      .then((res) => {
        if (res?.status === "success") {
          toast.success(
            res?.message ||
              (types === "block"
                ? "Room Blocked successfully"
                : "Room Unblocked successfully")
          );
          getBlock();
          setIsBlock({ ...isBlock, BlockedRooms: "" });
          setPopup(false);
        } else {
          console.log("res?.message", res);

          toast.error(res?.error || "Something went wrong");
          setPopup(false);
        }
        setLoading(false);
      })
      .catch((err) => {
        toast.error("Server error. Please try again.");
        setLoading(false);
        setPopup(false);
        console.error("Room Error:", err);
      });
  };

  console.log("isValue", isValue);
  const todays = new Date().toISOString().split("T")[0];
  return (
    <div>
      <Topbar
        header={`Room Booking ${
          type === "add" ? "Add" : type === "edit" ? "Edit" : "View"
        }`}
        subHead="Overall Properties"
      />

      <div className="mt-4 col-md-12">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 primary">
          {data?.property_room_category_name}
        </p>

        <div className="d-flex as-js mt-4">
          {/* LEFT SIDE */}
          <div className="col-md-6">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Calendar
            </p>
            <div className="roles-bg rounded-2 px-2 py-1 d-flex ac-js w-40">
              <img
                src={calender_icon}
                className="calender-icon me-2"
                alt="calendar"
                onClick={openFromDatePicker}
                style={{ cursor: "pointer" }}
              />
              <div style={{ width: "115px" }}>
                <p className="f3 fs-xs-10 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14">
                  From Range:
                </p>
                <input
                  id="fromDateInput"
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFormDate(e.target.value)}
                  className="border-0 w-100"
                  placeholder="From Date"
                  min={todays}
                />
              </div>
            </div>

            {/* ROOM DATA */}
            <div className="d-flex ac-js gap-4 mt-4 flex-wrap">
              <div className="tabs w-40 text-start ">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Total Rooms
                </p>
                <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 black">
                  {isValue?.total_rooms || 0}
                </p>
              </div>
              <div className="tabs w-40 text-start ">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 black">
                  Available Rooms
                </p>
                <div className="d-flex ac-jb">
                  <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 black">
                    {isValue?.total_available || 0}
                  </p>
                  {checkPermission("CAN-EDIT-ROOMS") && (
                    <button
                      onClick={() => {
                        setIsBlock({
                          ...isBlock,
                          AvailableRooms: isValue?.total_available,
                        });

                        setPopup(true);
                        setTypes("block");
                      }}
                      className="bg-gray2 rounded white px-2 p-1 f2 border-0"
                    >
                      Block
                    </button>
                  )}
                </div>
              </div>
              <div className="tabs w-40 text-start ">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 black">
                  Booked Rooms
                </p>
                <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 black">
                  {isValue?.total_booked || 0}
                </p>
              </div>
              <div className="tabs w-40 text-start ">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 black">
                  Blocked Rooms
                </p>
                <div className="d-flex ac-jb">
                  <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 black">
                    {isValue?.total_blocked || 0}
                  </p>
                  {checkPermission("CAN-EDIT-ROOMS") && (
                    <button
                      onClick={() => {
                        setIsBlock({
                          ...isBlock,
                          Blocked: isValue?.total_blocked,
                        });
                        setPopup(true);
                        setTypes("unblock");
                      }}
                      className="bg-green rounded white px-2 p-1 f2 border-0"
                    >
                      Unblock
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div style={{ marginTop: "2rem" }}>
              {data && data?.blocked_timeslots_history !== undefined ? (
                <RoomBookingTable
                  roomData={data && data?.blocked_timeslots_history}
                />
              ) : (
                <></>
              )}
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-md-6">
            <p className="f3 mb-1">Time Slot</p>
            <div className="d-flex flex-wrap roles-bg py-4 rounded-3 gap-3">
              {slotData.length > 0 ? (
                slotData.map((item, ind) => (
                  <button
                    key={item.key}
                    onClick={() => {
                      handlerAvailable(item, ind);
                    }}
                    className={tabs === ind ? "time-act-tabs" : "time-tabs"}
                  >
                    {item && item?.label}
                  </button>
                ))
              ) : (
                <p lassName="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                  No slot data. Please add a slot.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* POPUP */}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup p-0">
            <div className="d-flex ac-jb mb-4 p-4">
              <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 yellow">
                {fromDate}
              </p>
              <CancelOutlinedIcon
                className="pointer"
                onClick={() => {
                  setPopup(false);
                  setIsBlock({
                    ...isBlock,
                    BlockedRooms: "",
                  });
                }}
              />
            </div>
            <div className="w-100 mt-3 d-flex flex-wrap ac-jc gap-4">
              <div className="w-40">
                <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15  text-start">
                  {types === "block" ? "Available Rooms" : "Blocked Room"}
                </p>
                <input
                  className="roles-bg border-0 rounded-4 mt-1 w-100"
                  value={
                    types === "block"
                      ? isBlock?.AvailableRooms
                      : isBlock.Blocked
                  }
                  disabled
                  type="number"
                  placeholder="Available Rooms"
                />
              </div>
              <div className="w-40">
                <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 text-start">
                  {types === "block" ? "Blocked Rooms" : "UnBlocked Room"}
                </p>
                <input
                  className="roles-bg border-0 rounded-4 mt-1 w-100"
                  value={isBlock?.BlockedRooms}
                  onChange={(e) => {
                    if (types === "block") {
                      if (isBlock?.AvailableRooms >= e.target.value) {
                        setIsBlock({
                          ...isBlock,
                          BlockedRooms: e.target.value,
                        });
                      } else {
                        // toast.warn("More than the blocked rooms");
                        // setIsBlock({ ...isBlock, BlockedRooms: "" });
                      }
                    } else if (isBlock.Blocked >= e.target.value) {
                      setIsBlock({
                        ...isBlock,
                        BlockedRooms: e.target.value,
                      });
                    } else {
                      // toast.warn("More than the Unblocked rooms");
                      // setIsBlock({ ...isBlock, BlockedRooms: "" });
                    }
                  }}
                  type="number"
                  placeholder="Blocked Rooms"
                />
              </div>
            </div>

            <div className="d-flex ae-jb  mt-5">
              <button
                onClick={() => handleSubmit()}
                className="submit-btn w-100"
              >
                {types == "block" ? "Block" : "UnBlock"}
              </button>
            </div>
          </div>
        </div>
      )}
      {loading && <Loader />}
    </div>
  );
};

export default RoomBookingBlock;
